import React from 'react';
import NewsletterModal from './NewsletterModal';
import useNewsletterModal from '../../hooks/useNewsletterModal';

const NewsletterProvider = ({ children }) => {
    const { isModalOpen, closeModal } = useNewsletterModal();

    return (
        <>
            {children}
            <NewsletterModal 
                isOpen={isModalOpen} 
                onClose={closeModal}
            />
        </>
    );
};

export default NewsletterProvider;